import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useEffect } from "react";
import Select from "react-select";

const data = require("./oferta.json").data;
const findMat = (cod) => data.find((elem) => elem.cod == cod);

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    fontWeight: "normal",
    color: "black",
  }),
  option: (provided, state) => ({
    ...provided,
    fontWeight: state.isSelected ? "500" : "normal",
    color: state.isSelected ? "white" : "black",
  }),
};

function ProgramarInscripcion() {
  const [rowsData, setRowsData] = useState(Array(9).fill({ matSelected: "" }));

  const setcodMatSelected = (idx, val) => {
    let newData = [...rowsData];
    newData[idx] = { ...newData[idx], matSelected: val };
    setRowsData(newData);
  };

  let Thead = () => (
    <thead>
      <tr>
        <th scope="col" rowSpan="2">
          Cod. / Materia
        </th>
        <th scope="col" colSpan="3">
          Lunes
        </th>
        <th scope="col" colSpan="3">
          Martes
        </th>
        <th scope="col" colSpan="3">
          Miercoles
        </th>
        <th scope="col" colSpan="3">
          Jueves
        </th>
        <th scope="col" colSpan="3">
          Viernes
        </th>
        <th scope="col" colSpan="3">
          Sabado
        </th>
      </tr>
      <tr>
        <th>TM</th> <th>TT</th> <th>TN</th>
        <th>TM</th> <th>TT</th> <th>TN</th>
        <th>TM</th> <th>TT</th> <th>TN</th>
        <th>TM</th> <th>TT</th> <th>TN</th>
        <th>TM</th> <th>TT</th> <th>TN</th>
        <th>TM</th> <th>TT</th>
      </tr>
    </thead>
  );

  let Row = ({ index }) => {
    console.log("a", index);

    return (
      <tr>
        <td style={{ width: "25%" }}>
          <SubjectSelect
            idx={index}
            setMat={(x) => {
              setcodMatSelected(index, x);
            }}
          />
        </td>
        <DataShowed></DataShowed>
      </tr>
    );
  };

  let DataShowed = (codMat) => {
    return (
      <>
        <td>TM</td> <td>TT</td> <td>TN</td>
        <td>TM</td> <td>TT</td> <td>TN</td>
        <td>TM</td> <td>TT</td> <td>TN</td>
        <td>TM</td> <td>TT</td> <td>TN</td>
        <td>TM</td> <td>TT</td> <td>TN</td>
        <td>TM</td> <td>TT</td>
      </>
    );
  };

  function SubjectSelect({ setMat, idx }) {
    // Adding all the subjects to the select
    const opts = [];
    data.forEach((mat) => {
      opts.push({ value: mat.cod, label: mat.cod + " - " + mat.name });
    });

    console.log(idx);

    let prevValue;
    rowsData[idx].matSelected != ""
      ? (prevValue = findMat(rowsData[idx].matSelected).name)
      : (prevValue = "Elegir materia...");

    // The component
    return (
      <div styles={{ width: "100%" }}>
        <Select
          options={opts}
          styles={selectStyles}
          onChange={(op) => {
            setMat(op.value);
          }}
          placeholder={prevValue}
        />
      </div>
    );
  }

  return (
    <>
      <h1>Programador de Inscripción</h1>

      <div>
        <table
          className="table table-dark"
          style={{ width: "90%", margin: "auto" }}
        >
          <Thead></Thead>
          <tbody id="subjectsSelectionContainer">
            <Row index={1}></Row>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ProgramarInscripcion;
